import { Controller } from "@hotwired/stimulus";

// Shows pedal-specific fields (bypass_type) when the Pedal device type
// is selected. Hides and clears them otherwise so we do not save stale
// values when the user changes the device's primary class.
export default class extends Controller {
  static targets = ["pedalCheckbox", "bypassWrapper"];

  connect() {
    this.update();
  }

  update() {
    if (!this.hasPedalCheckboxTarget || !this.hasBypassWrapperTarget) return;
    const show = this.pedalCheckboxTarget.checked;
    this.bypassWrapperTarget.hidden = !show;
    if (!show) {
      const select = this.bypassWrapperTarget.querySelector('select[name*="[bypass_type]"]');
      if (select) select.value = "";
    }
  }
}
